import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@mui/material';
import { CaseForm, FileEvidences } from 'queries/cases/types';
import { useForm, useFormContext } from 'react-hook-form';
import { useSaveEvidences } from '../../hooks/useSaveEvidences';
import './Evidence.scss';
import { useTranslation } from 'react-i18next';
import { useGlobalNotification } from 'hooks';
import { Loading } from '@shape-ds/components';

interface Props extends FileEvidences {
  index: number;
  handleSubmit?: ReturnType<typeof useForm>['handleSubmit'];
}

export const Evidence = ({ name, isNew, handleSubmit }: Props) => {
  const { t } = useTranslation();
  const { displaySnackbar } = useGlobalNotification();
  const { watch, setValue } = useFormContext<CaseForm>();
  const eventId = watch('id') || '';
  const evidences = watch('evidences') || [];
  const { setFileToDownload, filesData, deleteMutation, refetchListFiles } = useSaveEvidences({
    eventId,
  });

  const handleDeleteFile = async () => {
    if (!filesData || !deleteMutation) return;

    deleteMutation.mutate(
      { keyName: filesData.key_name, keyType: 'RECORDS', fileName: name },
      {
        onSuccess: async () => {
          const updatedEvidences = evidences.filter(
            (evidence: FileEvidences) => evidence.name !== name,
          );
          setValue('evidences', updatedEvidences);

          await refetchListFiles();

          handleSubmit?.(() => {
            displaySnackbar({
              message: t('case:evidences.messages.delete_success'),
              type: 'success',
            });
          })();
        },
        onError: () => {
          displaySnackbar({
            message: t('case:evidences.messages.delete_error'),
            type: 'error',
          });
        },
      },
    );
  };

  return (
    <div className="evidence-item">
      {deleteMutation?.isLoading ? (
        <Loading />
      ) : (
        <>
          <div
            className="evidence-item-file"
            data-testid="new-file"
            id={`downloadFile-${name}`}
            onClick={() => {
              !isNew && setFileToDownload(name);
            }}
          >
            <span>{name}</span>
          </div>
          <div className="evidence-item-icon evidence-item-icon-trash">
            <IconButton onClick={handleDeleteFile} disabled={deleteMutation?.isLoading}>
              <FontAwesomeIcon icon={faTrashCan} />
            </IconButton>
          </div>
        </>
      )}
    </div>
  );
};
